$(document).ready(function () {
    // Function to close the mobile menu
    function closeMobileMenu() {
        $('.mobile-menu-icon').removeClass('expanded');
        $('.mobile-menu-icon').attr('aria-expanded', 'false');
        $('.mobile-menu-content').slideUp('fast');
        $('body').removeClass('menu-open');

        // Do not set focus if the menu is not open
        if ($('.mobile-menu-content').is(':visible')) {
            $('.mobile-menu-icon').focus();
        }
    }

    // Toggle mobile menu when icon is clicked
    $('.mobile-menu-icon').click(function (event) {
        var isExpanded = $('.mobile-menu-icon').attr('aria-expanded') === 'true';
        $('.mobile-menu-icon').toggleClass('expanded');
        $('.mobile-menu-icon').attr('aria-expanded', !isExpanded);
        $('.mobile-menu-content').slideToggle('fast');
        $('body').toggleClass('menu-open', !isExpanded);

        event.stopPropagation();
    });

    // Toggle search mobile content
    $('.search-mobile-icon').click(function (event) {
        $('.search-mobile-content').slideToggle('fast');
        var expanded = $('.search-mobile-icon').attr('aria-expanded') === 'false';
        $('.search-mobile-icon').attr('aria-expanded', expanded);
        if (expanded) {
            setTimeout(function () {
                $('.search-mobile-content input').focus();
            }, 300);
        }

        event.stopPropagation();
    });

    // Close mobile menu when clicking outside of it
    $(document).click(function (event) {
        if (!$(event.target).closest('.mobile-menu-content').length && !$(event.target).hasClass('mobile-menu-icon') && !$(event.target).closest('.mobile-menu-icon').length) {
            closeMobileMenu();
        }
    });

    // Handle tab key press to loop focus within the mobile menu
    $('.mobile-menu-content li:last-child').keydown(function (e) {
        if (e.which === 9 && !e.shiftKey) { // Tab key pressed
            e.preventDefault();
            $('.mobile-menu-content li:first-child a').focus(); // Set focus to the first item
        }
    });

    // Close mobile menu when Escape key is pressed
    $(document).keydown(function (e) {
        if (e.which === 27) { // Escape key pressed
            closeMobileMenu();
        }
    });
});
